import { useState, useEffect, useCallback } from 'react';
import { ApiFactory } from '../../core/config/ApiFactory';
import { IEstacaoKDS } from '../interfaces/IKDS';

const PREFIX = '/kds/estacoes';

export const useEstacoesKDS = () => {
    const [estacoes, setEstacoes] = useState<IEstacaoKDS[]>([]);
    const [loading, setLoading] = useState(false);
    const api = ApiFactory.getApi("MS_PRODUTOS");

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const res = await api.get(PREFIX);
            setEstacoes(res.data.estacoes ?? []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { carregar(); }, [carregar]);

    const salvar = async (dados: Partial<IEstacaoKDS>) => {
        if (dados.uuid) {
            await api.patch(`${PREFIX}/${dados.uuid}`, dados);
        } else {
            await api.post(PREFIX, dados);
        }
        await carregar();
    };

    const excluir = async (uuid: string) => {
        await api.delete(`${PREFIX}/${uuid}`);
        await carregar();
    };

    return { estacoes, loading, carregar, salvar, excluir };
};
